import {isEmpty, omitBy} from 'lodash-es';

import {isEnumInstance} from 'shared/utils';
import {TTableReportFormattedHeaders} from 'store/slices/table-report-slice/table-report-slice-types';

import {EDesignTemplates} from '../../table-report-types';

export const GET_VALUE_FROM_MENU_INDICATOR = '#MENU';

const dataSensitiveDesignTemplates = [
    EDesignTemplates.DECLARATION,
    EDesignTemplates.REGISTERS,
    EDesignTemplates.POSTING_CARD,
    EDesignTemplates.REGISTER_WITH_ROW_HEADERS,
];

export const shouldRenderHeader = (
    designTemplate: string | undefined,
    headers: TTableReportFormattedHeaders | undefined,
) => {
    // wrong designTemplate
    if (!designTemplate || !isEnumInstance(designTemplate, EDesignTemplates)) {
        return false;
    }
    // some templates don`t need headers to render
    if (!dataSensitiveDesignTemplates?.includes(designTemplate as EDesignTemplates)) {
        return true;
    }

    if (!headers) {
        return false;
    }

    return !isEmpty(omitBy(headers, isEmpty));
};
